<template>
  <v-container class="cart-page" max-width="1200">
    <v-row>
    <v-col cols="12" md="8">
      <v-list>
        <v-list-item
          v-for="(product, index) in cartItems"
          :key="index"
          class="cart-item"
        >
          <v-row>
            <v-col cols="4" class="d-flex flex-column align-center">
              <v-img :src="product.image" alt="Product Image" class="product-image"></v-img>
              <div class="align-center justify-center mt-2 pl-1">
              <div class="quantity">
                <div class="quantity-control">
                  <button @click="decreaseQuantity(product)" class="minus">-</button>
                  <input type="number" v-model.number="product.quantity" min="1" />
                  <button @click="increaseQuantity(product)" class="plus">+</button>
                </div>
              </div>
              </div>
            </v-col>
            <v-col cols="8" class="d-flex flex-column justify-space-between">
              <v-list-item>
                <v-list-item-title>{{ product.name }}</v-list-item-title>
                <v-list-item-subtitle class="original-price">${{ parseFloat(product.originalPrice).toFixed(2) }}</v-list-item-subtitle>
                <v-list-item-subtitle class="discounted-price">${{ parseFloat(product.discountedPrice).toFixed(2) }}</v-list-item-subtitle>
                <v-list-item-subtitle class="savings">{{ t('Savings') }}: ${{ (parseFloat(product.originalPrice) - parseFloat(product.discountedPrice)).toFixed(2) }}</v-list-item-subtitle>
              </v-list-item>
              <v-btn icon small class="align-self-end" @click="removeItem(product)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
    </v-col>
    <v-col cols="12" md="4">
      <v-card>
        <v-card-title>{{ t('cartPage.cartSummary') }}</v-card-title>
        <v-card-text>
          <div>{{ t('cartPage.subtotal') }}: ${{ cartSubtotal.toFixed(2) }}</div>
          <div>{{ t('cartPage.delivery') }}: {{ t('cartPage.payOnDelivery') }}</div>
          <div>{{ t('cartPage.total') }}: ${{ cartTotal.toFixed(2) }}</div>
          <div v-if="isLoggedIn">
            <div>{{ t('checkout.delivery_to') }}: {{ defaultAddress || t('checkout.addNewAddress') }}</div>
            <v-btn color="info" block align="center" @click="changeAddress">{{ t('checkout.changeAddress') }}</v-btn>
            <AddressForm :visible="showAddressForm" :address="addrObj" @addressSaved="saveAddress"></AddressForm>
          </div>
          <div v-else>
            <p>{{ t('checkout.pleaseLoginToSelectDeliveryAddress') }}</p>
            <v-btn color="warning" block align="center" @click="changeAddress">{{ t('checkout.addNewAddress') }}</v-btn>
            <AddressForm :visible="showAddressForm" :address="addrObj" @addressSaved="saveAddress"></AddressForm>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="info" block align="center" @click="proceedToCheckout">{{ t('cartPage.checkout') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
  </v-container>
</template>

<script setup>
import { useStore  } from 'vuex';
import { ref, onMounted, computed, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import AddressForm from '@/components/AddressForm.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const { proxy } = getCurrentInstance(); 
const router = useRouter();


const cartItems = ref([]);
const defaultAddress = ref('');
const addrObj = ref({});
const showAddressForm = ref(false);

const loadCartItems = () => {
    const cart = localStorage.getItem('cart');
    if(cart){
        let Cart = JSON.parse(cart);
        Cart.forEach(item => {
            let product = localStorage.getItem('product_'+ item.product_id);
            product = JSON.parse(product);
            if(product){
                product.originalPrice = Number(product.regularPrice);
                product.discountedPrice = Number(product.salePrice);
                Object.assign(item, product);
            }
        });
        cartItems.value = Cart;
    }
}

onMounted(() => {
    loadCartItems();
    const addr = localStorage.getItem('defaultAddress');
    if(addr != null && addr != ''){
      saveAddress(JSON.parse(addr));
      addrObj.value = JSON.parse(addr);
    }
});


const cartSubtotal = computed(() => {
    return cartItems.value.reduce((sum, item) => sum + item.discountedPrice * item.quantity, 0);
});

const cartTotal = computed(() => {
    return cartSubtotal.value;
});

const store = useStore();

const isLoggedIn = computed(() => {
    return store.getters.isUserLoggedIn;
});

const increaseQuantity = (item) => {
    item.quantity++;
    updateQuantity();
}

const decreaseQuantity = (item) => {
    if(item.quantity > 1){
        item.quantity--;
        updateQuantity();
    }
}

const updateQuantity = () => {
    localStorage.setItem('cart', JSON.stringify(cartItems.value));
}

const removeItem = (item) => {
    cartItems.value = cartItems.value.filter(i => i.id !== item.id);
    localStorage.setItem('cart', JSON.stringify(cartItems.value));
}

const proceedToCheckout = () => {
    if(cartItems.value.length > 0){
        if(defaultAddress.value == ''){
            proxy.$toast.error(t('Please set a default address'));
            return;
        }
        if(isLoggedIn.value){
            router.push('/checkout');
        }else{
          proxy.$toast.error(t('Please login to proceed to checkout'));
          return;
        }
    }else{
        proxy.$toast.error(t('Cart is empty'));
    }
}

const changeAddress = () => {
    showAddressForm.value = true;
}

const saveAddress = (address) => {
  console.log(address, 'address');
    defaultAddress.value = `${address.fullName}, ${address.phoneNumber}, ${address.street}, ${t('regions["'+address.region+'"]')}, ${address.postalCode}, ${t('countries["'+address.country+'"]')}`;
    localStorage.setItem('defaultAddress', JSON.stringify(address));
    showAddressForm.value = false;
}

</script>

<style scoped>

.cart-item {
  margin-bottom: 16px;
}

.product-image {
  width: 100%;
  height: auto;
}

.cart-page {
  padding: 20px;
}

.v-card {
  margin-top: 20px;
}
.quantity {
  margin-left: 35px;
}
.quantity-control {
    display: flex;
    align-items: flex-end;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-left: 20px;
}

.quantity-control button {
    width: 36px;
    height: 36px;
    border: none;
    background: none;
    cursor: pointer;
}

.quantity-control input {
    width: 60px;
    height: 36px;
    border: none;
    text-align: center;
}
/* 购物车总结 */
.cart-summary {
  flex: 1;
  border: 1px solid #ddd;
  padding: 20px;
  background-color: #f9f9f9;
  text-align: left;
}
</style> 